import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const IntroSection = (props) =>
{
  return (

    <section id="intro-section" class="section is-medium has-background-info">
      <div class="container">
        <div class="columns">
          <div class="column is-three-fifths" >
            <div data-sal="slide-right"
              data-sal-delay="300"
              data-sal-easing="ease" class="content" style={{ maxWidth: "85%" }}>
              <h1 class="title pb-5 mainfont has-text-dark">Dutch Tyres</h1>
              <p class="description  mainfont is-size-5 has-text-dark" >
                {props.description}
              </p>
            </div>
          </div>
          <div data-sal="slide-left"
            data-sal-delay="300"
            data-sal-easing="ease" class="column is-two-fifths mt-6">
            <div class="mt-6" style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}>
              <StaticImage

                src="../images/bandbrand.jpg"
                imgStyle={{ width: "100%" }}
                style={{ width: "100%" }}
                quality={95}
                formats={["AUTO", "WEBP", "AVIF"]}
                alt="Brand logo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default IntroSection;